// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from cc-zero.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function CcZeroIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7.983 0c2.238 0 4.148.78 5.72 2.342a7.662 7.662 0 0 1 1.715 2.582c.39.962.582 1.99.582 3.076a8.13 8.13 0 0 1-.583 3.087 7.262 7.262 0 0 1-1.703 2.526 8.213 8.213 0 0 1-2.655 1.77c-.99.41-2.018.617-3.076.617a7.902 7.902 0 0 1-3.042-.6 8.301 8.301 0 0 1-2.6-1.759A8.087 8.087 0 0 1 .6 11.042 7.84 7.84 0 0 1 0 8c0-1.057.2-2.07.6-3.042a8.12 8.12 0 0 1 1.77-2.633C3.893.772 5.764 0 7.983 0zm.034 1.44c-1.829 0-3.369.64-4.616 1.915a6.962 6.962 0 0 0-1.457 2.157 6.388 6.388 0 0 0 0 4.969 6.83 6.83 0 0 0 3.585 3.558c.79.324 1.62.487 2.488.487.857 0 1.681-.165 2.482-.498a6.88 6.88 0 0 0 2.184-1.446C13.931 11.364 14.56 9.838 14.56 8a6.57 6.57 0 0 0-.487-2.515 6.418 6.418 0 0 0-1.418-2.118C11.37 2.081 9.826 1.44 8.017 1.44zM8 3.395c2.641 0 3.305 2.492 3.305 4.605 0 2.113-.664 4.605-3.305 4.605S4.694 10.113 4.694 8l.007-.355c.073-2.027.804-4.25 3.299-4.25zm1.316 3.227L7.35 10.017c-.274.412-.083.645.219.774l.135.044c.091.022.19.034.297.034 1.357 0 1.422-1.938 1.422-2.869l-.007-.409a7.282 7.282 0 0 0-.06-.72l-.04-.25zM8 5.132c-1.258 0-1.406 1.66-1.421 2.646L6.577 8c0 .24.005.544.035.865l.027.244 1.759-3.232c.182-.316.09-.542-.101-.706A1.222 1.222 0 0 0 8 5.13z"
        />
      </g>
    </svg>
  );
}
